import { useState } from 'react';

export interface ToastItem {
  id: string;
  title?: string;
  description?: string;
  open?: boolean;
}

// Simple in-memory toast store
let toastList: ToastItem[] = [];
let listeners: Array<(toasts: ToastItem[]) => void> = [];

function notify() {
  listeners.forEach((l) => l([...toastList]));
}

export function toast(item: Omit<ToastItem, 'id'>) {
  const id = Math.random().toString(36).slice(2);
  toastList = [...toastList, { ...item, id, open: true }];
  notify();
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastItem[]>(toastList);

  // Subscribe on mount
  useState(() => {
    listeners.push(setToasts);
    return () => {
      listeners = listeners.filter((l) => l !== setToasts);
    };
  });

  return { toasts, toast };
}
